import JoinGame from "./JoinGame";
import useTranslation from "next-translate/useTranslation";
import { useLobby, setTab } from "../../ducks/lobby";
import {
  LIVE_GAME_TAB,
  DAILY_TAB,
  DAILY_GAMES_TAB,
  CREATE_GAME_TAB,
} from "@chesshotel/constants";
import CLobbyMain from "./daily/CLobbyMain";
import CActive from "./daily/CActive";
import { useDaily } from "../../ducks/daily";
import { UserDailyGame } from "@chesshotel/types";
import { useEffect, useRef } from "react";
import CreateGame from "./CreateGame";
import Tabs from "./Tabs";
import PlayersOnline from "./PlayersOnline";

export default function LobbyBody({ isDesktop }) {
  const { t } = useTranslation("common");

  const { invites, tab } = useLobby();
  const { games } = useDaily();

  // const prevIsDesktop = useRef(isDesktop);

  const gameArr = Object.values(games);
  let myTurnGames = 0;

  const nrInvites = invites.length;

  gameArr.forEach((game: any) => {
    if (game.turn && game.resultId == null) {
      myTurnGames++;
    }
  });
  const onGoingGames = gameArr.filter(
    (game: UserDailyGame) => game.resultId == null
  );

  const hasGames = onGoingGames.length != 0;

  let nrTabs = isDesktop ? 2 : 3;
  if (hasGames) {
    nrTabs = isDesktop ? 3 : 4;
  }

  useEffect(() => {
    // if (prevIsDesktop.current != isDesktop) {
    if (isDesktop && tab == CREATE_GAME_TAB) {
      setTab(LIVE_GAME_TAB);
    }
    // }
    // prevIsDesktop.current = isDesktop;
  }, [isDesktop]);

  useEffect(() => {
    if (!hasGames && tab == DAILY_GAMES_TAB) {
      setTab(DAILY_TAB);
    }
  }, [hasGames]);

  function renderSelectedTab() {
    if (tab === CREATE_GAME_TAB) {
      return <CreateGame isDesktop={isDesktop} />;
    } else if (tab === LIVE_GAME_TAB) {
      return <JoinGame />;
    } else if (tab === DAILY_TAB) {
      return <CLobbyMain />;
    } else if (tab === DAILY_GAMES_TAB) {
      return <CActive />;
    }
  }

  function handleCreate() {
    setTab(CREATE_GAME_TAB);
  }

  function handleLive() {
    setTab(LIVE_GAME_TAB);
  }

  function handleDaily() {
    setTab(DAILY_TAB);
  }

  function handleGames() {
    setTab(DAILY_GAMES_TAB);
  }

  return (
    <div className="flex justify-center w-full border border-b-[3px] rounded-b-md rounded-t-xl bg-white h-[518px] md:h-[488px]">
      <div className="relative flex flex-col items-center w-full ">
        <Tabs nrTabs={nrTabs}>
          {!isDesktop && (
            <Tabs.Tab
              mobile
              selected={tab === CREATE_GAME_TAB}
              nrTabs={nrTabs}
              onClick={handleCreate}
            >
              {t("Create")}
            </Tabs.Tab>
          )}

          <Tabs.Tab
            selected={tab === LIVE_GAME_TAB}
            nrTabs={nrTabs}
            onClick={handleLive}
          >
            {t("Live")}
            {nrInvites > 0 && tab !== LIVE_GAME_TAB && (
              <div className="absolute top-0 bottom-0 right-0 flex items-center justify-center w-5 h-5 my-auto text-white -translate-x-1/2 rounded-lg md:hidden bg-altblue-300 md:w-6 md:h-6">
                {nrInvites}
              </div>
            )}
          </Tabs.Tab>
          <Tabs.Tab
            selected={tab === DAILY_TAB}
            nrTabs={nrTabs}
            onClick={handleDaily}
          >
            {t("Daily")}
          </Tabs.Tab>
          {hasGames && (
            <Tabs.Tab
              selected={tab === DAILY_GAMES_TAB}
              nrTabs={nrTabs}
              onClick={handleGames}
            >
              {t("Games")}
              {myTurnGames > 0 && tab !== DAILY_GAMES_TAB && (
                <div className="absolute top-0 bottom-0 right-0 flex items-center justify-center w-5 h-5 my-auto text-white -translate-x-1/2 bg-red-300 rounded-lg bg-opacity-80 md:w-6 md:h-6">
                  {myTurnGames}
                </div>
              )}
            </Tabs.Tab>
          )}
        </Tabs>
        {renderSelectedTab()}
        <div className="absolute bottom-0 z-10 flex w-full pb-4 bg-white md:hidden">
          {<PlayersOnline />}
        </div>
      </div>
    </div>
  );
}
